import React from 'react';

const speechUrl = 'https://news.stanford.edu/stories/2005/06/youve-got-find-love-jobs-says';
const photoUrl = 'https://www.albertwatson.net/all-photos';

export default function PortfolioInspiration() {
  return <section id="ispirazione" className="fl-showcase-section pf-inspiration-section" aria-labelledby="pf-inspiration-title">
    <div className="pf-motto" data-reveal>
      <span className="fl-eyebrow">IL MIO MOTTO</span>
      <h2 id="pf-inspiration-title" lang="en">Think <em>different.</em></h2>
      <p>Curiosità, passione e il coraggio di provare una strada diversa. È lo spirito che porto nei miei progetti.</p>
    </div>
    <figure className="pf-inspiration" data-reveal>
      <div className="pf-inspiration-photo"><img src="/images/steve-jobs-watson.jpg" alt="Steve Jobs con la mano al mento, ritratto di Albert Watson del 2006" width="1570" height="2000" loading="lazy" decoding="async" /></div>
      <figcaption className="pf-inspiration-copy">
        <span className="fl-eyebrow">DALLA MIA TESI MAGISTRALE · 2021</span>
        <span className="pf-quote-mark" aria-hidden="true">“</span>
        <blockquote lang="en">If you haven’t found it yet, <em>keep looking. Don’t settle.</em></blockquote>
        <div className="pf-quote-author"><strong>Steve Jobs</strong><a href={speechUrl} target="_blank" rel="noopener noreferrer">Stanford Commencement Address · 2005</a></div>
        <p className="pf-photo-credit">Ritratto: <a href={photoUrl} target="_blank" rel="noopener noreferrer">© Albert Watson · Cupertino, 2006</a></p>
      </figcaption>
    </figure>
  </section>;
}
